import React from 'react'

interface CattlesLogoProps {
	width?: number | string
	height?: number | string
	color?: string
	onClick?: () => void
	style?: React.CSSProperties
}

const CattlesLogo: React.FC<CattlesLogoProps> = ({
	width = 24,
	height = 24,
	color = '#7F7F84',
	onClick,
	style,
}) => (
	<svg
		width={width}
		height={height}
		viewBox='0 0 24 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		onClick={onClick}
		style={{ cursor: onClick ? 'pointer' : 'default', ...style }}
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M6.80506 3.84875C6.82554 3.4015 6.47957 3.02232 6.03232 3.00184C5.58506 2.98136 5.20589 3.32733 5.18541 3.77458C5.12583 5.07553 5.47498 6.00576 6.06234 6.73253C6.51224 7.28922 7.10397 7.71378 7.5935 8.06501C7.69095 8.13493 7.78436 8.20195 7.87178 8.26652L8.18627 8.4988L8.56384 8.39732C10.7841 7.80056 12.9971 7.80056 15.2174 8.39732L15.595 8.4988L15.9095 8.26652C15.9969 8.2019 16.0904 8.13483 16.188 8.06485C16.6774 7.7137 17.269 7.28924 17.7189 6.73273C18.3063 6.00602 18.6554 5.07584 18.5958 3.77489C18.5753 3.32763 18.1962 2.98167 17.7489 3.00215C17.3017 3.02263 16.9557 3.4018 16.9762 3.84906C17.0188 4.7807 16.7797 5.31536 16.4579 5.71352C16.1581 6.08442 15.7814 6.35669 15.3004 6.70435L15.2585 6.73466C13.015 6.19299 10.7662 6.19298 8.52276 6.73466L8.48126 6.70466L8.48126 6.70466C8.00009 6.35686 7.62323 6.08446 7.32335 5.71341C7.00149 5.31515 6.76239 4.7804 6.80506 3.84875ZM4.12915 10.4033C3.76974 10.122 3.45494 9.684 3.13383 8.95103C3.73811 8.85628 4.43761 8.8352 5.08633 8.97638C6.02547 9.18078 6.82095 9.7052 7.16351 10.8825C7.75459 12.914 8.59432 15.5012 9.27246 17.5319C8.87126 18.1123 8.6339 18.7663 8.6339 19.3266C8.6339 20.7127 10.087 20.9998 11.8795 20.9998C13.672 20.9998 15.1252 20.7127 15.1252 19.3266C15.1252 18.8441 14.9491 18.2921 14.644 17.7775C15.3354 15.7132 16.2199 12.9968 16.8351 10.8825C17.1777 9.7052 17.9732 9.18078 18.9123 8.97638C19.561 8.8352 20.2605 8.85628 20.8648 8.95103C20.5437 9.684 20.2289 10.122 19.8695 10.4033C19.4049 10.7668 18.7402 10.9646 17.5176 10.9863C17.07 10.9943 16.7135 11.3636 16.7215 11.8113C16.7294 12.2589 17.0988 12.6154 17.5464 12.6074C18.8957 12.5835 19.9901 12.3676 20.8687 11.6801C21.7316 11.0049 22.258 9.97209 22.7231 8.64198L22.9986 7.85408L22.203 7.60167C21.3127 7.31921 19.9098 7.09999 18.5675 7.39212C17.1769 7.69476 15.8209 8.56468 15.2783 10.4296C14.7487 12.2499 14.0137 14.5318 13.3788 16.4459C12.9303 16.1586 12.4204 15.9801 11.8795 15.9801C11.4176 15.9801 10.9783 16.1103 10.5805 16.3273C9.95476 14.438 9.23904 12.2124 8.72029 10.4296C8.17768 8.56468 6.8217 7.69476 5.43112 7.39212C4.08885 7.09999 2.68596 7.31921 1.79561 7.60167L1 7.85408L1.27552 8.64198C1.74065 9.97209 2.26708 11.0049 3.12995 11.6801C4.00849 12.3676 5.10291 12.5835 6.45222 12.6074C6.89987 12.6154 7.26921 12.2589 7.27716 11.8113C7.28511 11.3636 6.92867 10.9943 6.48101 10.9863C5.25845 10.9646 4.5937 10.7668 4.12915 10.4033Z'
			fill={color}
		/>
	</svg>
)

export default CattlesLogo
